/* Collection SEO redesign — continuous image motion.
   Layered sine waves with non-matching frequencies: the composite
   never loops, so there is no keyframe boundary pause. Matches the
   design-handoff ProductFigure animation. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  var images = document.querySelectorAll('.mti-r-figure--animated .mti-r-figure__img[data-mti-r-animate="true"]');
  if (!images.length) return;

  images.forEach(function (el) {
    var start = performance.now();
    function tick(now) {
      var t = (now - start) / 1000;
      var x = Math.sin(t * 0.55) * 7 + Math.sin(t * 0.23 + 1.3) * 4;
      var y = -14 + Math.sin(t * 0.38 + 0.4) * 9 + Math.cos(t * 0.19) * 6;
      var r = Math.sin(t * 0.31 + 0.9) * 1.6 + Math.sin(t * 0.17) * 1.1;
      el.style.transform = 'translate3d(' + x.toFixed(2) + 'px, ' + y.toFixed(2) + 'px, 0) rotate(' + r.toFixed(3) + 'deg)';
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  });
})();
